export default __webpack_public_path__ + "static/media/youtube.b9d99867.svg";